import { EventEmitter } from 'events';
import { useEffect, useRef } from 'react';
import { useBrowser } from '../services/BrowserService';

const ONSCROLL_EVENT = 'on_scroll';

type EventArgs = { x: number; prevX: number; y: number; previousY: number };

type EventCallback = (args: EventArgs) => void;

export const useOnScroll = () => {
  const browser = useBrowser();
  const previousY = useRef<number>(0);
  const previousX = useRef<number>(0);
  const event = new EventEmitter();

  useEffect(() => {
    if (browser.window) {
      browser?.window.addEventListener('scroll', handleScroll);
    }

    return () => {
      browser.window?.removeEventListener('scroll', handleScroll);
      event.removeAllListeners();
    };
  });

  const handleScroll = () => {
    if (!browser.window || !browser.document) return;

    const doc = browser.document.documentElement;
    const y = (browser.window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    const x = (browser.window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);

    setTimeout(() => {
      previousY.current = y;
      previousX.current = x;
    });

    event.emit(ONSCROLL_EVENT, {
      x,
      previousX: previousX.current,
      y,
      previousY: previousY.current,
    });
  };

  const onScroll = (callback: EventCallback) => {
    event.on(ONSCROLL_EVENT, callback);
  };

  return onScroll;
};
